module.exports = __webpack_public_path__ + "img/map-school.ecfa7b2d.svg";